export class Beneficiary {
  constructor(
    public firstname: string,
    public profile: { id: number },
    // public roleBeneficiary: { id: number },
    public roles: { id: number },
    public lastname: string,
    public dateBirth: string,
    public gender: { id: number },
    public city: { id: number; name: string },
    public country: {
      id: number;
      name: string;
      PhoneCode: string;
      flag: string;
    },
    public email: string,
    public phoneNumberOne: string,
    public phoneNumberTwo: string,
    public password: string,
    public created_By?: string,
    public stemdUsers?: {
      beneficiary: string;
      classe: string;
      createdAt: string;
      created_by: string;
      etablissement: string;
      id: number;
      niveau: string;
      profil: string;
      serie: string;
      updatedAt: string;
    }
  ) {}
}
